/* Gardrop Seçkisi FW 26/27 - ortak davranışlar */
(function () {
  if (window.FW26) return;
  var FW = (window.FW26 = {});
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  FW.norm = function (s) {
    return (s || '')
      .toLocaleLowerCase('tr')
      .replace(/ı/g, 'i').replace(/i̇/g, 'i').replace(/ş/g, 's').replace(/ç/g, 'c')
      .replace(/ğ/g, 'g').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/â/g, 'a');
  };
  FW.money = function (cents) {
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Math.round(cents / 100)) + ' TL';
  };

  /* görünür olunca */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, window.matchMedia('(max-width: 749px)').matches ? { rootMargin: '0px 0px 12% 0px', threshold: 0 } : { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  FW.reveal = function (root) {
    (root || document).querySelectorAll('[data-fw-reveal]:not(.is-in)').forEach(function (el) {
      if (io && !reduce) io.observe(el); else el.classList.add('is-in');
    });
  };

  /* raylar */
  FW.rail = function (root) {
    (root || document).querySelectorAll('[data-fw-rail]:not([data-fw-ready])').forEach(function (rail) {
      rail.setAttribute('data-fw-ready', '');
      var track = rail.querySelector('[data-fw-track]');
      if (!track) return;
      var prev = rail.querySelector('[data-fw-prev]'), next = rail.querySelector('[data-fw-next]');
      var bar = rail.querySelector('[data-fw-bar] i');
      function step() {
        var c = track.firstElementChild; if (!c) return track.clientWidth;
        var w = c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 14);
        return w * Math.max(1, Math.floor(track.clientWidth / w) - 1);
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        if (bar) {
          var vis = Math.min(1, track.clientWidth / track.scrollWidth);
          bar.style.width = vis * 100 + '%';
          bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
      var down = false, sx = 0, sl = 0, moved = 0;
      track.addEventListener('mousedown', function (e) { down = true; moved = 0; sx = e.pageX; sl = track.scrollLeft; });
      window.addEventListener('mouseup', function () { if (!down) return; down = false; track.classList.remove('is-drag'); });
      window.addEventListener('mousemove', function (e) {
        if (!down) return;
        var dx = e.pageX - sx; moved = Math.max(moved, Math.abs(dx));
        if (moved > 6) { track.classList.add('is-drag'); e.preventDefault(); track.scrollLeft = sl - dx; }
      });
      track.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    });
  };

  /* filtre + daha fazla */
  FW.applyFilter = function (scope) {
    var active = scope.querySelector('[data-fw-filter].is-active');
    var key = active ? active.getAttribute('data-fw-filter-key') : null;
    var vals = active ? active.getAttribute('data-fw-filter').split(',').map(FW.norm).filter(Boolean) : ['*'];
    var limit = parseInt(scope.getAttribute('data-fw-limit') || '9999', 10);
    var items = scope.querySelectorAll('[data-fw-item]');
    var shown = 0, matched = 0;
    var any = vals.indexOf('*') > -1;
    var test = function (it) {
      if (any || !key) return true;
      var v = FW.norm(it.getAttribute('data-' + key));
      if (key === 'price') return vals.indexOf(v) > -1;
      return vals.some(function (x) { return v.indexOf(x) > -1; });
    };
    var hits = [];
    items.forEach(function (it) { if (test(it)) hits.push(it); });
    var fallback = !hits.length && scope.hasAttribute('data-fw-fallback');
    items.forEach(function (it) {
      var ok = fallback ? true : hits.indexOf(it) > -1;
      if (ok) matched++;
      var vis = ok && shown < limit;
      if (vis) shown++;
      it.hidden = !vis;
    });
    var more = scope.querySelector('[data-fw-more]');
    if (more) more.hidden = matched <= shown;
    var count = scope.querySelector('[data-fw-count]');
    if (count) count.textContent = matched;
    var empty = scope.querySelector('[data-fw-empty]');
    if (empty) empty.hidden = matched > 0;
    scope.classList.toggle('is-filtered', !(any || !key));
    scope.querySelectorAll('[data-fw-after]').forEach(function (ed) {
      ed.hidden = !(any || !key) || parseInt(ed.getAttribute('data-fw-after'), 10) > shown;
    });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fw-filter]');
    if (b) {
      var scope = b.closest('[data-fw-scope]'); if (!scope) return;
      scope.querySelectorAll('[data-fw-filter]').forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b); });
      var base = scope.getAttribute('data-fw-base-limit');
      if (base) scope.setAttribute('data-fw-limit', base);
      FW.applyFilter(scope);
      scope.dispatchEvent(new CustomEvent('fw:filter', { detail: { button: b } }));
      return;
    }
    var m = e.target.closest('[data-fw-more]');
    if (m) {
      var sc = m.closest('[data-fw-scope]');
      var step = parseInt(sc.getAttribute('data-fw-step') || '8', 10);
      sc.setAttribute('data-fw-limit', parseInt(sc.getAttribute('data-fw-limit'), 10) + step);
      FW.applyFilter(sc);
    }
  });

  /* hızlı ekle */
  var toastEl, toastT;
  FW.toast = function (html) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'fw-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = html;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  };
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fw-quick-toggle]');
    if (t) { e.preventDefault(); var card = t.closest('.fw-card'); if (card) card.classList.toggle('is-quick'); return; }
    var b = e.target.closest('[data-fw-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    b.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-fw-add'), 10), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Ürün eklenemedi'); return j; }); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-js-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var card = b.closest('.fw-card'); if (card) card.classList.remove('is-quick');
        var name = b.getAttribute('data-fw-name') || '';
        var size = b.getAttribute('data-fw-size') || '';
        // temanın sepet çekmecesi bu olayla kendini yeniler
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: { cart: cart } }));
        var icon = Array.prototype.find.call(document.querySelectorAll('[data-js-cart-icon]'), function (x) { return x.offsetParent !== null; });
        if (icon) setTimeout(function () { icon.click(); }, 700);
        FW.toast('<span><b>' + esc(name) + '</b>' + (size ? ' · ' + esc(size) : '') + ' sepete eklendi</span><a href="/cart">Sepete git</a>');
      })
      .catch(function (err) { FW.toast('<span>' + esc(err.message) + '</span>'); })
      .then(function () { b.classList.remove('is-loading'); });
  });

  /* yavaş kaydırma efekti */
  var px = [];
  FW.parallax = function (root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-fw-parallax]:not([data-fw-px])').forEach(function (el) { el.setAttribute('data-fw-px', ''); px.push(el); });
  };
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      px.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var k = parseFloat(el.getAttribute('data-fw-parallax')) || 0.12;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * k * -100).toFixed(2) + 'px,0) scale(1.12)';
      });
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* videolar ekrandayken oynasın */
  FW.videos = function (root) {
    (root || document).querySelectorAll('[data-fw-video] video:not([data-fw-v])').forEach(function (v) {
      v.setAttribute('data-fw-v', ''); v.muted = true; v.playsInline = true; v.loop = true;
      if (!('IntersectionObserver' in window)) { v.play().catch(function () {}); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) v.play().catch(function () {}); else v.pause(); });
      }, { threshold: 0.25 }).observe(v);
    });
  };
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-fw-sound]');
    if (!s) return;
    var v = s.closest('[data-fw-video]').querySelector('video');
    if (!v) return;
    v.muted = !v.muted; s.classList.toggle('is-on', !v.muted);
    s.setAttribute('aria-label', v.muted ? 'Sesi aç' : 'Sesi kapat');
    if (v.paused) v.play().catch(function () {});
  });

  /* açılış: mobilde paneller parmakla kayar, kendiliğinden de ilerler */
  FW.hero = function (root) {
    (root || document).querySelectorAll('[data-fw-hero]:not([data-fw-ready])').forEach(function (h) {
      h.setAttribute('data-fw-ready', '');
      var track = h.querySelector('[data-fwh-track]');
      var panels = h.querySelectorAll('.fwh__panel'), dots = h.querySelectorAll('.fwh__dots i');
      if (panels.length < 2 || !track) return;
      var i = 0, t = null, st = null, touching = false, mq = window.matchMedia('(max-width: 749px)');
      function setOn(n) {
        panels[i].classList.remove('is-on'); if (dots[i]) dots[i].classList.remove('is-on');
        i = n;
        panels[i].classList.add('is-on'); if (dots[i]) { void dots[i].offsetWidth; dots[i].classList.add('is-on'); }
      }
      function arm() {
        clearTimeout(t);
        t = setTimeout(function () {
          if (mq.matches && !document.hidden && !touching) track.scrollTo({ left: ((i + 1) % panels.length) * track.clientWidth, behavior: 'smooth' });
          arm();
        }, 5000);
      }
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          if (!mq.matches) return;
          var n = Math.max(0, Math.min(panels.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
          if (n !== i) { setOn(n); arm(); }
        }, 80);
      }, { passive: true });
      track.addEventListener('touchstart', function () { touching = true; }, { passive: true });
      track.addEventListener('touchend', function () { touching = false; arm(); }, { passive: true });
      arm();
    });
  };

  /* yana kaydırılan alanlarda konum çubuğu */
  FW.swipe = function (root) {
    (root || document).querySelectorAll('[data-fw-swipe]:not([data-fw-ready])').forEach(function (sc) {
      sc.setAttribute('data-fw-ready', '');
      var next = sc.nextElementSibling;
      var bar = next && next.matches('.fw-swipe-bar') ? next.querySelector('i') : next && next.querySelector('.fw-swipe-bar i');
      if (!bar) return;
      function sync() {
        var vis = sc.scrollWidth ? Math.min(1, sc.clientWidth / sc.scrollWidth) : 1;
        var max = sc.scrollWidth - sc.clientWidth;
        bar.parentElement.style.visibility = vis >= 0.99 ? 'hidden' : '';
        bar.style.width = vis * 100 + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (sc.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0) + '%)';
      }
      sc.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      var sec = sc.closest('.fw'); if (sec) sec.addEventListener('click', function () { setTimeout(sync, 30); });
      sync();
    });
  };

  /* renk hikâyesi */
  document.addEventListener('fw:filter', function (e) {
    var sec = e.target.closest('[data-fw-colors]'); if (!sec) return;
    var b = e.detail.button, idx = b.getAttribute('data-fwc-i');
    sec.style.setProperty('--tint', b.getAttribute('data-fwc-color'));
    sec.querySelectorAll('[data-fwc-img]').forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-fwc-img') === idx); });
    var name = sec.querySelector('[data-fwc-name]');
    if (name) {
      name.style.opacity = 0; name.style.transform = 'translateY(30%)';
      setTimeout(function () { name.textContent = b.getAttribute('data-fwc-label'); name.style.opacity = 1; name.style.transform = 'none'; }, 260);
    }
  }, true);

  /* tek parça sekmeleri */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fwo-tab]'); if (!t) return;
    var sec = t.closest('[data-fw-onepiece]'), k = t.getAttribute('data-fwo-tab');
    sec.querySelectorAll('[data-fwo-tab]').forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
    sec.querySelectorAll('[data-fwo-piece]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-fwo-piece') === k); });
    FW.reveal(sec);
  });

  /* kombin aracı */
  FW.mix = function (root) {
    (root || document).querySelectorAll('[data-fw-mix]:not([data-fw-ready])').forEach(function (m) {
      m.setAttribute('data-fw-ready', '');
      var rows = {};
      m.querySelectorAll('[data-fwx]').forEach(function (r) { rows[r.getAttribute('data-fwx')] = r.querySelector('[data-fwx-track]'); });
      function cur(track) {
        if (!track || !track.children.length) return null;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        return track.children[Math.max(0, Math.min(track.children.length - 1, i))];
      }
      function update() {
        var total = 0, ok = 0;
        ['top', 'bottom'].forEach(function (k) {
          var c = cur(rows[k]), out = m.querySelector('[data-fwx-out="' + k + '"]');
          if (!c || !out) return;
          out.href = c.getAttribute('data-url');
          var th = out.querySelector('[data-fwx-thumb]'); if (th) th.style.backgroundImage = 'url(' + c.getAttribute('data-thumb') + ')';
          out.querySelector('[data-fwx-name]').textContent = c.getAttribute('data-name');
          out.querySelector('[data-fwx-price]').textContent = c.getAttribute('data-price-fmt');
          total += parseInt(c.getAttribute('data-price'), 10) || 0; ok++;
        });
        var t = m.querySelector('[data-fwx-total]'); if (t && ok) t.textContent = FW.money(total);
        m.classList.remove('is-swapping');
      }
      var tm;
      Object.keys(rows).forEach(function (k) {
        var tr = rows[k]; if (!tr) return;
        tr.addEventListener('scroll', function () { m.classList.add('is-swapping'); clearTimeout(tm); tm = setTimeout(update, 120); }, { passive: true });
      });
      m.addEventListener('click', function (e) {
        var st = e.target.closest('[data-fwx-step]');
        if (st) {
          var tr = st.closest('[data-fwx]').querySelector('[data-fwx-track]');
          var n = tr.children.length, i = Math.round(tr.scrollLeft / tr.clientWidth) + parseInt(st.getAttribute('data-fwx-step'), 10);
          i = (i + n) % n;
          tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' });
          return;
        }
        if (e.target.closest('[data-fwx-shuffle]')) {
          Object.keys(rows).forEach(function (k, j) {
            var tr = rows[k]; if (!tr || !tr.children.length) return;
            var i = Math.floor(Math.random() * tr.children.length);
            setTimeout(function () { tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); }, j * 180);
          });
        }
      });
      update();
      // bölüme yaklaşınca tüm kareleri önceden yükle, kaydırınca beklemesin
      var imgs = m.querySelectorAll('.fwx__cell img');
      var warm = function () { imgs.forEach(function (im) { im.loading = 'eager'; if (im.decode) im.decode().catch(function () {}); }); };
      if ('IntersectionObserver' in window) {
        var wio = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { warm(); wio.disconnect(); } }, { rootMargin: '900px 0px' });
        wio.observe(m);
      } else warm();
    });
  };

  /* aynı adlı filtre çiplerini birleştir (ÜST GİYİM / Üst Giyim) */
  FW.dedupe = function (root) {
    (root || document).querySelectorAll('[data-fw-dedupe]').forEach(function (g) {
      var seen = {};
      g.querySelectorAll('[data-fw-filter]').forEach(function (b) {
        var v = FW.norm(b.getAttribute('data-fw-filter'));
        if (seen[v]) { b.remove(); return; }
        seen[v] = b;
      });
    });
  };


  /* sahne arkası: videolar sırayla, biten videodan sonrakine geçer */
  FW.stories = function (root) {
    (root || document).querySelectorAll('[data-fw-stories]:not([data-fw-ready])').forEach(function (sec) {
      sec.setAttribute('data-fw-ready', '');
      var track = sec.querySelector('[data-fwb-track]');
      var slides = [].slice.call(sec.querySelectorAll('[data-fwb-slide]'));
      if (!slides.length) return;
      var stillMs = (parseInt(sec.getAttribute('data-fwb-still'), 10) || 14) * 1000;
      var idx = 0, visible = false, muted = true, timer = null, raf = null, t0 = 0;
      slides.forEach(function (sl) { var v = sl.querySelector('video'); if (v) { v.muted = true; v.playsInline = true; v.loop = false; v.removeAttribute('loop'); v.preload = 'metadata'; } });
      function center() {
        var sl = slides[idx], vp = track.parentElement;
        var x = vp.clientWidth / 2 - (sl.offsetLeft + sl.offsetWidth / 2);
        track.style.transform = 'translate3d(' + x + 'px,0,0)';
      }
      function bars() {
        var sl = slides[idx], v = sl.querySelector('video');
        var p = v && v.duration ? v.currentTime / v.duration : Math.min(1, (performance.now() - t0) / stillMs);
        sl.querySelectorAll('.fwb__bars b').forEach(function (b, i) { b.style.transform = 'scaleX(' + (i < idx ? 1 : i === idx ? p : 0) + ')'; });
        raf = requestAnimationFrame(bars);
      }
      function play() {
        clearTimeout(timer); cancelAnimationFrame(raf);
        slides.forEach(function (sl, i) {
          var v = sl.querySelector('video');
          sl.classList.toggle('is-active', i === idx);
          if (v && i !== idx) { v.pause(); try { v.currentTime = 0; } catch (e) {} }
        });
        center();
        if (!visible) return;
        var v = slides[idx].querySelector('video');
        t0 = performance.now();
        if (v) { v.muted = muted; var pr = v.play(); if (pr) pr.catch(function () { v.muted = true; v.play().catch(function () {}); }); }
        else timer = setTimeout(function () { go(idx + 1); }, stillMs);
        raf = requestAnimationFrame(bars);
      }
      function go(i) { idx = (i + slides.length) % slides.length; play(); }
      slides.forEach(function (sl, i) {
        var v = sl.querySelector('video');
        if (v) v.addEventListener('ended', function () { if (i === idx) go(idx + 1); });
        sl.addEventListener('click', function () { if (i !== idx) go(i); });
      });
      sec.addEventListener('click', function (e) {
        var st = e.target.closest('[data-fwb-step]'); if (st) { go(idx + parseInt(st.getAttribute('data-fwb-step'), 10)); return; }
        var sd = e.target.closest('[data-fwb-sound]');
        if (sd) { muted = !muted; sd.classList.toggle('is-on', !muted); sd.setAttribute('aria-label', muted ? 'Sesi aç' : 'Sesi kapat'); var v = slides[idx].querySelector('video'); if (v) { v.muted = muted; v.play().catch(function () {}); } }
      });
      var sx = null;
      track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1)); });
      window.addEventListener('resize', center);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            visible = e.isIntersecting;
            if (visible) play(); else { clearTimeout(timer); cancelAnimationFrame(raf); var v = slides[idx].querySelector('video'); if (v) v.pause(); }
          });
        }, { threshold: 0.3 }).observe(sec);
      } else { visible = true; play(); }
      center();
    });
  };

  FW.init = function (root) {
    FW.dedupe(root); FW.hero(root); FW.swipe(root); FW.mix(root); FW.stories(root);
    FW.reveal(root); FW.rail(root); FW.parallax(root); FW.videos(root);
    (root || document).querySelectorAll('[data-fw-scope]').forEach(FW.applyFilter);
    onScroll();
  };
  if (document.readyState !== 'loading') FW.init(); else document.addEventListener('DOMContentLoaded', function () { FW.init(); });
  document.addEventListener('shopify:section:load', function (e) { FW.init(e.target); });
})();
